// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_17_2-tooltip {
  /* Typography */
  --perxis-auto-tooltip-font-family-inner: var(
    --perxis-auto-tooltip-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-tooltip-font-size-inner: var(
    --perxis-auto-tooltip-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-tooltip-font-weight-inner: var(
    --perxis-auto-tooltip-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-tooltip-letter-spacing-inner: var(
    --perxis-auto-tooltip-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-tooltip-line-height-inner: var(
    --perxis-auto-tooltip-line-height,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-tooltip-text-transform-inner: var(
    --perxis-auto-tooltip-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-tooltip-font-variant-numeric-inner: var(
    --perxis-auto-tooltip-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  --perxis-auto-tooltip-color-inner: var(
    --perxis-auto-tooltip-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-tooltip-background-color-inner: var(
    --perxis-auto-tooltip-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-tooltip-border-radius-inner: var(--perxis-auto-tooltip-border-radius, 8px);
  /* End Border */
  /* Padding */
  --perxis-auto-tooltip-padding-inner: var(--perxis-auto-tooltip-padding, 6px 12px);
  /* End Padding */
  /* Sizes */
  --perxis-auto-tooltip-max-width-inner: var(--perxis-auto-tooltip-max-width, 250px);
  /* End Padding */
  /* Box Shadow */
  --perxis-auto-tooltip-box-shadow-inner: var(
    --perxis-auto-tooltip-box-shadow,
    0 6px 16px 0 rgb(38 38 38 / 8%),
    0 3px 6px -4px rgb(38 38 38 / 12%),
    0 9px 28px 8px rgb(38 38 38 / 5%)
  );
  /* End Box Shadow */
  /* Z-index */
  --perxis-auto-tooltip-dropdown-z-index-inner: var(--perxis-auto-tooltip-dropdown-z-index, 1000);
  /* End Z-index */
}
.perxis-auto-1_17_2-tooltip.ant-5_24_1-tooltip {
  font-family: var(--perxis-auto-tooltip-font-family-inner);
  font-size: var(--perxis-auto-tooltip-font-size-inner);
  line-height: var(--perxis-auto-tooltip-line-height-inner);
  font-weight: var(--perxis-auto-tooltip-font-weight-inner);
  text-transform: var(--perxis-auto-tooltip-text-transform-inner);
  letter-spacing: var(--perxis-auto-tooltip-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-tooltip-font-variant-numeric-inner);
  color: var(--perxis-auto-tooltip-color-inner);
  z-index: var(--perxis-auto-tooltip-dropdown-z-index-inner);
  max-width: var(--perxis-auto-tooltip-max-width-inner);
}
.perxis-auto-1_17_2-tooltip.ant-5_24_1-tooltip .ant-5_24_1-tooltip-inner {
  min-height: auto;
  color: var(--perxis-auto-tooltip-color-inner);
  background-color: var(--perxis-auto-tooltip-background-color-inner);
  border: 0;
  border-radius: var(--perxis-auto-tooltip-border-radius-inner);
  box-shadow: var(--perxis-auto-tooltip-box-shadow-inner);
  padding: var(--perxis-auto-tooltip-padding-inner);
  overflow-wrap: anywhere;
}
.perxis-auto-1_17_2-tooltip.ant-5_24_1-tooltip .ant-5_24_1-tooltip-arrow {
  --antd-arrow-background-color: var(--perxis-auto-tooltip-background-color-inner);
}

.perxis-auto-1_17_2-tooltip-content {
  --perxis-auto-tooltip-content-row-gap-inner: var(
    --perxis-auto-tooltip-content-row-gap,
    var(--perxis-auto-gap-vertical-blue-inner)
  );
  row-gap: var(--perxis-auto-tooltip-content-row-gap-inner);
}

.perxis-auto-1_17_2-tooltip-title {
  --perxis-auto-tooltip-title-column-gap-inner: var(
    --perxis-auto-tooltip-title-column-gap,
    var(--perxis-auto-gap-vertical-blue-inner)
  );
  flex-wrap: nowrap;
  justify-content: space-between;
  column-gap: var(--perxis-auto-tooltip-title-column-gap-inner);
}

.perxis-auto-1_17_2-tooltip-button {
  display: inline-flex;
  cursor: pointer;
  max-width: 100%;
}

.perxis-auto-1_17_2-tooltip-close-button {
  /* Typography */
  --perxis-auto-tooltip-close-icon-color-inner: var(
    --perxis-auto-tooltip-close-icon-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-button-text-color: var(--perxis-auto-tooltip-close-icon-color-inner);
  display: flex;
  float: right;
  padding-left: inherit;
}

.perxis-auto-1_17_2-tooltip-trigger {
  max-width: 100%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
